/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { BlockSnapshot } from "@vienna/common";

import { MoveCommand } from "src/classes/plate/Command";
import { Plate } from "src/classes/plate/Plate";
import { ArrowSessionSnapshot } from "src/classes/plate/Session";
import { BaseSession } from "src/classes/plate/Session/BaseSession";
import { SessionType } from "src/classes/plate/Session/session.types";

export class ArrowSession extends BaseSession<ArrowSessionSnapshot> {
  readonly initialBlockSnapshots: BlockSnapshot[];

  plate: Plate;

  private constructor(snapshot: ArrowSessionSnapshot, plate: Plate) {
    super(snapshot);
    this.plate = plate;
    this.initialBlockSnapshots = this.plate.selectedBlocks.map((block) => block.snapshot);
  }

  public start(): void {
    // The reason we do nothing here is because there is already a key down listener.
  }

  public cancel(): void {
    this.end();
  }

  public end(): void {
    const cmd = new MoveCommand(this, this.plate);
    this.plate.addToHistory(cmd);
  }

  /* -------------------------------------------------- */
  /*                   Static Methods                   */
  /* -------------------------------------------------- */
  public static create(plate: Plate): ArrowSession {
    const initialSnapshot: ArrowSessionSnapshot = {
      type: SessionType.Arrow,
    };
    return new ArrowSession(initialSnapshot, plate);
  }
}
